import { Alert, Heading, Modal, Paragraph, Text, TextButton } from '@zillow/constellation-10';
import type { ListingDescriptionModalProps } from './BoostWidget.types';

export const ListingDescriptionModal = ({ title, address, description }: ListingDescriptionModalProps) => {
  return (
    <Modal
      size={{ base: 'fullScreen', lg: 'sm' }}
      header={
        <Heading level={6} css={{ textAlign: 'center' }}>
          Listing description
        </Heading>
      }
      body={
        <>
          <Alert css={{ marginBottom: 'lg' }}>
            Save time by copying details from your listing description to quickly create Facebook and Instagram ads.
          </Alert>
          <Paragraph textStyle="body-sm-bold">{title}</Paragraph>
          <Paragraph textStyle="body-sm-bold" css={{ marginBottom: 'lg' }}>
            {address}
          </Paragraph>
          <Paragraph css={{ marginBottom: 'lg' }}>{description}</Paragraph>
        </>
      }
      trigger={
        <TextButton asChild>
          <button type="button">
            <Text textStyle="body-sm-bold" css={{ color: 'blue.500' }}>
              See listing description
            </Text>
          </button>
        </TextButton>
      }
    />
  );
};
